export default function decodeHtmlEntities( str ) {
	return str
		.replace( /&#(\d+);/g, ( m, code ) => String.fromCharCode( code ) )
		.replace( /&amp;/g, '&' )
		.replace( /&lt;/g, '<' )
		.replace( /&gt;/g, '>' )
		.replace( /&quot;/g, '"' )
		.replace( /&#39;/g, "'" );
}
